export default [
  {
    locale: 'ru',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags/ru.png'),
    name: 'Русский',
  },
  {
    locale: 'uz',
    // eslint-disable-next-line global-require
    img: require('@/assets/images/flags/uz.png'),
    name: 'O`zbek',
  },
]
